var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, react/forbid-prop-types, react/jsx-closing-bracket-location, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var ApiOptions = require("../perseus-api.jsx").Options;
var Changeable = require("../mixins/changeable.jsx");

var Editor = require("../editor.jsx");

var GroupEditor = React.createClass({
    displayName: "GroupEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        content: React.PropTypes.string,
        widgets: React.PropTypes.object,
        images: React.PropTypes.object,
        metadata: React.PropTypes.any,
        apiOptions: ApiOptions.propTypes
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            content: "",
            widgets: {},
            images: {},
            // `undefined` instead of `null` so that getDefaultProps works for
            // `the GroupMetadataEditor`
            metadata: undefined
        };
    },

    render: function render() {
        return React.createElement(
            "div",
            { className: "perseus-group-editor" },
            React.createElement(
                "div",
                null,
                this._renderMetadataEditor()
            ),
            React.createElement(Editor, {
                ref: "editor",
                content: this.props.content,
                widgets: this.props.widgets,
                apiOptions: this.props.apiOptions,
                images: this.props.images,
                widgetEnabled: true,
                immutableWidgets: false,
                onChange: this.props.onChange
            })
        );
    },

    _renderMetadataEditor: function _renderMetadataEditor() {
        var GroupMetadataEditor = this.props.apiOptions.GroupMetadataEditor;
        return React.createElement(GroupMetadataEditor, {
            value: this.props.metadata,
            onChange: this.change("metadata")
        });
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    getSaveWarnings: function getSaveWarnings() {
        return this.refs.editor.getSaveWarnings();
    },

    serialize: function serialize() {
        return _.extend({}, this.refs.editor.serialize(), {
            metadata: this.props.metadata
        });
    }
});

module.exports = GroupEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/group-editor.jsx
 ** module id = 111
 ** module chunks = 0 1
 **/